<template>
    <div>
      <VueEditor v-model="texto" :editorToolbar="customToolbar"/>
    </div>
</template>
<script>
export default {
  props: ['mensagem'],
  data: () => ({
    texto: '<h1>Escreva seu email aqui</h1>',
    customToolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', { 'color': [] }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }]
    ]
  }),
  beforeMount () {
    this.texto = this.mensagem
  },
  watch: {
    texto (val) {
      this.$emit('editarTexto', val)
    }
  }
}
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
